import { render, staticRenderFns } from "./TemplateDetailLayout.vue?vue&type=template&id=3d64dcb6&scoped=true"
import script from "./TemplateDetailLayout.vue?vue&type=script&lang=js"
export * from "./TemplateDetailLayout.vue?vue&type=script&lang=js"
import style0 from "./TemplateDetailLayout.vue?vue&type=style&index=0&id=3d64dcb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d64dcb6",
  null
  
)

export default component.exports